import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export type NavTab = 'admin' | 'restaurant';

type NavTabsProps = {
  value: NavTab;
  onChange: (tab: NavTab) => void;
};

/** The drawer's Ylläpito / Ravintola switch between the admin and the restaurant nav. */
const NavTabs: React.FC<NavTabsProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <StyledTabs value={value} onChange={(_, tab: NavTab) => onChange(tab)} centered>
      <StyledTab value="admin" label={t('nav.tabs.admin')} disableRipple />
      <StyledTab value="restaurant" label={t('nav.tabs.restaurant')} disableRipple />
    </StyledTabs>
  );
};

const StyledTabs = styled(Tabs)`
  min-height: 0;
  padding-top: 38px;

  & .MuiTabs-flexContainer {
    gap: ${({ theme }) => theme.spacing(4)};
  }

  & .MuiTabs-indicator {
    height: 1px;
    background-color: ${({ theme }) => theme.palette.common.white};

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }
`;

const StyledTab = styled(Tab)`
  min-width: 0;
  min-height: 0;
  padding: 0 0 3px;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  line-height: 1.5;
  text-transform: none;
  color: ${({ theme }) => theme.palette.common.white};
  opacity: 0.8;

  /* The theme colours a selected tab primary, which doesn't show on the green drawer. */
  &.Mui-selected {
    color: ${({ theme }) => theme.palette.common.white};
    opacity: 1;
  }

  &:hover {
    opacity: 1;
  }
`;

export default NavTabs;
